import React, { FC } from 'react'
import { Heading, Text, Modal, Button, ButtonType } from '@saasalerts/ui'
export const Recipients: FC<
  React.PropsWithChildren<{
    open: boolean
    setOpen: (open: boolean) => void
    emails: string[]
  }>
> = ({ open, setOpen, emails }) => {
  return (
    <Modal open={open} setOpen={setOpen}>
      <Modal.Header>
        <Modal.TitleBar>
          <Heading type="h2">Shared With</Heading>
        </Modal.TitleBar>
      </Modal.Header>
      <Modal.Body>
        <Text size="sm">{emails.map((email) => email).join(', ')}</Text>
      </Modal.Body>
      <Modal.Footer>
        <Button
          kind={ButtonType.OUTLINE_WHITE}
          onClick={() => {
            setOpen(false)
          }}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
